import { AnaColumn } from "../forms-template.service";
import { aspect } from "./aspect";

export const contatto: AnaColumn[] = [
  {
    configuration:
    {
      titleGriglia: 'Anagrafiche azienda',
      titleForm: '$descrizioneSoggetto',
      breadcrumbCaption: 'Anagrafica azienda',
      campoTitle: ['descrizioneSoggetto'],
      masterKey: 'id',
      service: 'Contatto',
      api: 'Contatto',
      filterList: '?NomeTabella=$NomeTabella&IdTabella=$IdTabella',
      helpDoc: 'Contatti.html',
      queryFilter: [],
      filterEditor: '/$',
      formType: 'simple',
      idTabRif: [],
      nCol: 1,


    }

  },
  {
    itemType: "group", colCount: "2", class: '', caption: 'Dati contatto', data: [

      { dataField: "id", colVisible: false, type: 'campo', dataType: "", caption: "ID", hideOnEdit: true, showEditorAlways: false },

      {
        maxLength: "60", colVisible: true, maxSize: 60, type: 'campo', dataField: "titolo", caption: "Titolo",
        labelWidth: 90, nCol:9,
      },
     
      {
        maxLength: "60",
        maxSize: 60,
        type: 'campo',
        dataField: "nome",
        caption: "Nome",
        nCol: 9,

        colVisible: true,
        validation: [
          { type: "required", message: "Campo Obbligatorio" },

        ],
      },
      {
        type: 'empty',
        colSpan: '1',
        nCol: 1,
        dataField: "", colVisible: false, dataType: "", hideOnEdit: false,
      },
      {
        maxLength: "60", maxSize: 60,
        type: 'campo',
        dataField: "cognome",
        caption: "Cognome",
        nCol: 9,
        colVisible: true,
        validation: [
          { type: "required", message: "Campo Obbligatorio" },

        ],
      },
      {
        type: 'empty',
        colSpan: '1',
        nCol: 1,
        dataField: "", colVisible: false, dataType: "", hideOnEdit: false,
      },
      { maxLength: "15",  
      maxSize: 15, 
      type: 'campo', 
      dataField: "telUfficio", 
      caption: "Tel.Ufficio", 
      dataType: "", 
      nCol: 4,
      colVisible: true,
     },

      { maxLength: "15", 
      maxSize: 15, 
      type: 'campo', 
      dataField: "telMobile", 
      caption: "Mobile",
       dataType: "", 
       colVisible: true, 
       labelWidth:120,
       nCol: 5,
      },
      {
        type: 'empty',
        colSpan: '1',
        nCol: 1,
        dataField: "", colVisible: false, dataType: "", hideOnEdit: false,
      },
      {
        type: 'empty',
        colSpan: '1',
        nCol: 1,
        dataField: "", colVisible: false, dataType: "", hideOnEdit: false,
      },
      { maxLength: "255", 
      type: 'campo', 
      dataField: "email", 
      caption: "Email", 
      dataType: "", 
      colVisible: true, 
      nCol:9,
    },
    {
      type: 'empty',
      colSpan: '1',
      nCol: 1,
      dataField: "", colVisible: false, dataType: "", hideOnEdit: false,
    },
      { 
      maxLength: "255",  
      type: 'campo', 
      dataField: "pec", 
      caption: "Pec",  
      dataType: "",
      nCol:9,
      colVisible: false
     },
     {
      type: 'empty',
      colSpan: '1',
      nCol: 1,
      dataField: "", colVisible: false, dataType: "", hideOnEdit: false,
    },
      { maxLength: "255", 
      maxSize: 45, 
      type: 'campo', 
      dataField: "skype", 
      caption: "Skype", dataType: "", 
      nCol:9, 
      colVisible: false },
      {
        type: 'empty',
        colSpan: '1',
        nCol: 1,
        dataField: "", colVisible: false, dataType: "", hideOnEdit: false,
      },
      { maxLength: "255", width:100, nCol:9, colVisible: false, maxSize: 255, type: 'campo', dataField: "note", caption: "Note", dataType: "", editorType: "dxTextArea", },
      {
        type: 'empty',
        colSpan: '1',
        nCol: 1,
        dataField: "", colVisible: false, dataType: "", hideOnEdit: false,
      },
      {
        type: 'empty',
        colSpan: '1',
        nCol: 1,
        dataField: "", colVisible: false, dataType: "", hideOnEdit: false,
      },
     
    ]
  },
]